import { createSlice } from "@reduxjs/toolkit";
const authSlice = createSlice({
    name: "auth",
    initialState: {},
    reducers: {
        add(state, action) {
            return state = action.payload;
        },
        update(state, action) {
            state.userInfo = { ...state.userInfo, ...action.payload }
        },
        clearStore(state, action) {
            return state = {}
        }
    },
});
export const { add, update, clearStore } = authSlice.actions;
export default authSlice.reducer;